export default __webpack_public_path__ + "static/media/ic_finland.215d835c.svg";